import { useCallback } from 'react';

import {
  type CommonListInsertAt,
  commonDelete,
} from '../../../redux/common_list/thunks';
import type { StoreEntityKey } from '../../../redux/entities/types';
import { useAppDispatch } from '../../../redux/redux_hooks';
import type { AppDispatch } from '../../../redux/types';
import { useListState } from './use_list_state';

type Config = {
  insertAt?: CommonListInsertAt;
};

type UseEntityListDeleteOptions<
  EntityType extends StoreEntityKey,
  ListName extends string,
> = {
  entityType: EntityType;
  listName: ListName;
  deleteItems?: (dispatch: AppDispatch, ids: string[]) => Promise<unknown>;
  config?: Config;
};

export function useEntityListDelete<
  EntityType extends StoreEntityKey,
  ListName extends string,
>({ deleteItems, listName }: UseEntityListDeleteOptions<EntityType, ListName>) {
  const dispatch = useAppDispatch();
  useListState(listName);

  const deleteEntities = useCallback(
    async (ids: string[]) => {
      if (!deleteItems) {
        return;
      }
      return commonDelete({
        listName,
        ids,
        deletePromise: deleteItems(dispatch, ids),
        dispatch,
      });
    },
    [deleteItems, listName],
  );

  return {
    deleteEntities,
  };
}
